/**
 * GODA BASE JS
 * Announcement bar rotation · Mobile nav · Product card hover
 */

'use strict';

/* ============================================================
   Announcement Bar — auto-rotation, pause on hover
   ============================================================ */
class GodaAnnouncementBar {
  constructor(el) {
    this.el = el;
    this.messages = Array.from(el.querySelectorAll('.goda-announcement-bar__message'));
    this.current = 0;
    this.interval = parseInt(el.dataset.interval || '5000', 10);
    this.timer = null;

    if (this.messages.length <= 1) return;

    this.start();
    this.el.addEventListener('mouseenter', () => this.pause());
    this.el.addEventListener('mouseleave', () => this.start());

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pause();
      } else {
        this.start();
      }
    });
  }

  start() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.next(), this.interval);
  }

  pause() {
    clearInterval(this.timer);
  }

  next() {
    const prev = this.messages[this.current];
    prev.classList.remove('is-active');
    prev.setAttribute('aria-hidden', 'true');
    this.current = (this.current + 1) % this.messages.length;
    const next = this.messages[this.current];
    next.classList.add('is-active');
    next.setAttribute('aria-hidden', 'false');
  }
}

/* ============================================================
   Product Card Hover — instant image swap (no transition)
   ============================================================ */
function initProductCardHover() {
  document.querySelectorAll('.goda-product-card__media-link').forEach(card => {
    const secondary = card.querySelector('.goda-product-card__img--secondary');
    if (!secondary) return;

    card.addEventListener('mouseenter', () => {
      secondary.style.opacity = '1';
    });

    card.addEventListener('mouseleave', () => {
      secondary.style.opacity = '0';
    });
  });
}

/* ============================================================
   Mobile Nav Overlay
   ============================================================ */
class GodaMobileNav {
  constructor() {
    this.overlay = document.querySelector('.goda-nav-overlay');
    this.openBtn = document.querySelector('.goda-header__hamburger');
    this.closeBtn = document.querySelector('.goda-nav-overlay__close');
    this.isOpen = false;

    if (!this.overlay) return;

    this.openBtn?.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());

    // Close on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });

    // Close on overlay click (outside links)
    this.overlay.addEventListener('click', e => {
      if (e.target === this.overlay) this.close();
    });
  }

  open() {
    this.isOpen = true;
    this.overlay.classList.add('is-open');
    this.overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    this.openBtn?.setAttribute('aria-expanded', 'true');
    // Focus first link
    const firstLink = this.overlay.querySelector('.goda-nav-overlay__link');
    firstLink?.focus();
  }

  close() {
    this.isOpen = false;
    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.openBtn?.setAttribute('aria-expanded', 'false');
    this.openBtn?.focus();
  }
}

/* ============================================================
   Init
   ============================================================ */
function godaInit() {
  document.querySelectorAll('.goda-announcement-bar').forEach(el => {
    if (!el._goda) {
      el._goda = new GodaAnnouncementBar(el);
    }
  });

  initProductCardHover();

  if (!window._godaMobileNav) {
    window._godaMobileNav = new GodaMobileNav();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', godaInit);
} else {
  godaInit();
}

// Re-init on Shopify section reload (theme editor)
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', () => {
    window._godaMobileNav = null;
    godaInit();
  });
}
